export const AccountSetupStatusTypes = Object.freeze({
  INITIAL: 0,
  ACCOUNT_CREATED: 1,
  SIGNUP_COMPLETED: 2,
  TENANT_SETUP_COMPLETED: 3,
});
